// Per-variant description.
//
// 9.2.0's product-info refetches the product section on variant change and hands the
// parsed document to variantChange subscribers, so the copy for the newly selected
// variant is already rendered in it. Copy it across by id, the same way the theme
// itself updates Price, Badges and Inventory.
//
// This replaces the three forked theme bundles (theme.dev.js, theme-variants.dev.js,
// theme-custom.dev.js), which existed only because 6.1.0 had four different
// product.liquid versions emitting two different variant-metafield payloads.
if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
	window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
		if (!data || !data.html) return;

		document.querySelectorAll('[data-product-variant-description-container]').forEach((live) => {
			const fresh =
				(live.id && data.html.getElementById(live.id)) ||
				data.html.querySelector('[data-product-variant-description-container]');

			if (fresh) live.innerHTML = fresh.innerHTML;
		});
	});
}

// Add to cart opens Rebuy Smart Cart, not the cart page.
//
// Every store runs cart_type "page" with Rebuy Smart Cart on top. 6.1.0's
// addToCart was hand-edited to post the add and stop there, so Smart Cart (which
// watches /cart/add) opened in place. 9.2.0's product-form redirects to /cart
// whenever the form is not bound to the theme's own drawer, which sent shoppers
// on US, AU, UK, CA and NZ to the native cart page. Its drawer branch only resets
// the button and fires theme:cart:refresh, which is what 6.1.0 did, so report
// the form as drawer-bound while Smart Cart is on the page. Checked per add, so
// if Rebuy has not loaded the theme still falls back to the cart page.
//
// ponytail: patches a vendor instance field through the prototype. If a theme
// update renames isCartDrawer, the redirect comes back; re-check this on upgrade.
const ProductForm = customElements.get('product-form');
if (ProductForm) {
	const smartCart = () => !!(window.Rebuy && window.Rebuy.SmartCart);

	Object.defineProperty(ProductForm.prototype, 'isCartDrawer', {
		configurable: true,
		get() { return this._isCartDrawer || smartCart(); },
		set(value) { this._isCartDrawer = value; },
	});

	// Forms connected before this script ran hold an own property that shadows the accessor.
	document.querySelectorAll('product-form').forEach((form) => {
		if (!Object.prototype.hasOwnProperty.call(form, 'isCartDrawer')) return;
		const value = form.isCartDrawer;
		delete form.isCartDrawer;
		form.isCartDrawer = value;
	});
}

// Get the navbar
const navbar = document.getElementById("NavStandard");
//Get the announcement bar
const announcementBar = document.querySelector(".announcement-bar-static");

// Not every page uses the standard header or the static announcement bar.
if (navbar && announcementBar) {
	// Get the offset position of the navbar
	const sticky = navbar.offsetTop;

	// When the user scrolls the page, execute stickyFunction
	window.addEventListener("scroll", function() {
		stickyFunction(sticky)
	});
}

// Add the sticky class to the announcement bar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyFunction(sticky) {
	if (window.pageYOffset > sticky) {
		announcementBar.classList.add("announcement-bar-sticky")
	} else {
		announcementBar.classList.remove("announcement-bar-sticky");
	}
}